import { render, staticRenderFns } from "./referral.vue?vue&type=template&id=4e20b778&scoped=true&"
import script from "./referral.vue?vue&type=script&lang=js&"
export * from "./referral.vue?vue&type=script&lang=js&"
import style0 from "./referral.vue?vue&type=style&index=0&id=4e20b778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20b778",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReferralHero: require('/opt/render/project/src/channels2022/src/components/referral/ReferralHero.vue').default,ReferralBenefits: require('/opt/render/project/src/channels2022/src/components/referral/ReferralBenefits.vue').default,ReferralSteps: require('/opt/render/project/src/channels2022/src/components/referral/ReferralSteps.vue').default,HomeFaqs: require('/opt/render/project/src/channels2022/src/components/home-page/HomeFaqs.vue').default,ReferralStartEarningBtn: require('/opt/render/project/src/channels2022/src/components/referral/ReferralStartEarningBtn.vue').default})
